"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _index = require("@/model/letter/index.js");

var _index2 = require("@/utils/index.js");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _i18n = require("@/assets/js/i18n");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      showDisplay: false,
      checked: false,
      pageLoading: false,
      messageList: [],
      pageInfo: {
        pageCount: 1,
        pageCurrent: 1,
        pageSize: 8,
        pageTotal: 6
      }
    };
  },
  components: {
    NoData: _NoData.default
  },
  created: function created() {
    this.getMessageList();
  },
  mounted: function mounted() {
    this.startTimer();
  },
  computed: {
    textSwitch: function textSwitch() {
      if (this.showDisplay == false) {
        return "详情";
      } else {
        return "收起";
      }
    }
  },
  methods: {
    translateTitle: _i18n.translateTitle,
    onClickDetails: function onClickDetails() {},
    startTimer: function startTimer() {
      var _this = this;

      this.getMessageList().then(function () {
        var timer = setTimeout(function () {
          _this.startTimer();
        }, 5000);

        _this.$once("hook:beforeDestroy", function () {
          clearTimeout(timer);
        });
      });
    },
    getMessageList: function getMessageList() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var req, _yield$apiGetMessageL, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = {
                  page: _this2.pageInfo.pageCurrent,
                  pageSize: _this2.pageInfo.pageSize
                };
                _context.next = 3;
                return (0, _index.apiGetMessageList)(req);

              case 3:
                _yield$apiGetMessageL = _context.sent;
                status = _yield$apiGetMessageL.status;
                data = _yield$apiGetMessageL.data;

                if (status == 200) {
                  data.list.forEach(function (ele) {
                    ele.showDisplay = false;
                    ele.create_time = (0, _index2.parseTime)(ele.create_time);
                    ele.conLength = ele.content.length;
                  });
                  _this2.messageList = data.list;
                  _this2.pageInfo = data.pageInfo;
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onReadMessage: function onReadMessage(item) {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var req, _yield$apiReadMessage, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = {
                  message_id: item.message_id
                };
                _context2.next = 3;
                return (0, _index.apiReadMessage)(req);

              case 3:
                _yield$apiReadMessage = _context2.sent;
                status = _yield$apiReadMessage.status;
                data = _yield$apiReadMessage.data;

                if (status == 200) {
                  item.status = 2;
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onReadAll: function onReadAll() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var req, _yield$apiReadMessage2, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                req = {
                  message_id: -1
                };
                _context3.next = 3;
                return (0, _index.apiReadMessage)(req);

              case 3:
                _yield$apiReadMessage2 = _context3.sent;
                status = _yield$apiReadMessage2.status;
                data = _yield$apiReadMessage2.data;

                if (status == 200) {
                  _this3.getMessageList();
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onCurrentPageChange: function onCurrentPageChange() {
      this.getMessageList();
    }
  }
};
exports.default = _default;